import React, { useEffect, useState } from "react";
import axios from "axios";
import Styles from "./Profile.module.css";
import Layout from "../Layout/Layout";
import Loading from "../Loading/Loading";
import Card from "./Card/Card";
import { Subscribe } from "unstated";
import RECSPContainer from "../../Store/recspContainer";
import { useLocation } from "wouter";
import { Button } from "@material-ui/core";

export default function Profile(props) {
  const [Data, setData] = useState({});
  const [load, setLoad] = useState(true);
  const [location, setLocation] = useLocation();

  useEffect(() => { loadProfile() }, []);

  function loadProfile() {
    axios
      .get(
        props.check.state.apiUrl + "getProfile.php?key=" + props.check.state.publicKey,
        props.check.state.config
      )
      .then((res) => {
        setData(res.data.data);
        setLoad(false);
      });
  }

  const checkBranch = (value) => (
    {1:"Computer Science",2:"Electronics and Communication",3:"Civil Engineering",4:"Mechanical Engineering",5:"Electrical Engineering"}[value]
  );

  const checkGender = (g) => g === "m" ? "Male" : "Female";
  const checkType   = (t) => t === "admin" ? "Admin" : "Student";

  const LogoutPortal = (doLogout) => { doLogout(); setLocation("/") }

  return (
    <>
      {load ? <Loading /> :
      <Layout>
        <div className="container-fluid">
          <div className="row">

            {/* BACKGROUND */}
            <div className={`col-lg-12 ${Styles.img}`}>
              <div className={`${Styles.circle} ${Styles.circle1}`}></div>
              <div className={`${Styles.circle} ${Styles.circle2}`}></div>
            </div>

            {/* MAIN BOX */}
            <div className="col-lg-12">
              <div className={Styles.box}>

                {/* PROFILE IMAGE (CENTER TOP) */}
                <div className={Styles.profileImg}>
                  <img src={"https://recstudentportal.com/" + Data.image} alt="profile" />
                </div>

                {/* PROFILE DETAILS GRID */}
                <div className={Styles.detailsGrid}>
                  <Card topic="Name" data={Data.name} />
                  <Card topic="Reg ID" data={Data.regid} />
                  <Card topic="Email" data={Data.email} />
                  <Card topic="Session" data={Data.session} />
                  <Card topic="Branch" data={checkBranch(Data.branch)} />
                  <Card topic="Gender" data={checkGender(Data.gender)} />
                  <Card topic="Birth" data={Data.birth} />
                  <Card topic="Blood" data={Data.blood} />
                  <Card topic="Type" data={checkType(Data.type)} />
                </div>

                {/* LOGOUT BUTTON (CENTERED) */}
                <Subscribe to={[RECSPContainer]}>
                  {(rec) => (
                    <Button className={Styles.logBtn}
                      variant="contained"
                      onClick={() => LogoutPortal(rec.doLogout)}>
                      LOGOUT
                    </Button>
                  )}
                </Subscribe>

              </div>
            </div>

          </div>
        </div>
      </Layout>}
    </>
  );
}
